__turbopack_context__.v({
  "boxed": "Button-module__7yC3Qa__boxed",
  "button": "Button-module__7yC3Qa__button",
  "icon": "Button-module__7yC3Qa__icon",
  "loading": "Button-module__7yC3Qa__loading",
});
